<template lang="">
    <div id="footer">
        <div class="inner_footer">
            <div class="footer_top">
                <h1><span>Blossom</span>Logos</h1>
                <ul>
                    <li><a href="#" @click.prevent="$router.push('/api-guide/api-guide-funeral')">API 연계가이드</a></li>
                    <li><a href="/customer-service/privacy-policy">개인정보처리방침</a></li>
                    <li><a href="/customer-service/terms-of-use">이용약관</a></li>
                    <li style="display:none"><a href="">이메일 무단수집거부</a></li>
                    <li style="display:none"><a href="">불편사항신고센터</a></li>
                    <li style="display:none"><a href="">서비스 업체소개</a></li>
                </ul>
            </div>
            <div class="footer_bottom">
                <div class="company_info"><span>대표이사 : 김대균</span> <span>개인정보취급책임자 : 임호근</span> <span>사업자등록번호: 661-88-03585</span> <span>회사명: (주)블라썸로고스</span></div>
                <div class="company_info"><span>경기도 하남시 서하남로 142 2층 (감일동)</span> <span>대표번호. 02)478-5821</span> <!--<span>F. 02)464-3009</span>--></div>
                <p>COPYRIGHTⓒ BlossomLogos ALL RIGHTS RESERVED. <span>CONTACT WEBMASTER FOR MORE INFORMATION</span></p>
                <div class="sns_wrap" style="display:none">
                    <a href=""><img src="@/assets/images/common/ico_insta.png" alt="인스타그램"></a>
                    <a href=""><img src="@/assets/images/common/ico_youtube.png" alt="유튜브"></a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="">

</style>